<template>
  <div
    role="dialog"
    id="radix-_r_26_"
    aria-describedby="radix-_r_28_"
    aria-labelledby="radix-_r_27_"
    data-state="open"
    class="gap-4 p-6"
    tabindex="-1"
    style="pointer-events: auto"
  >
    <div class="flex flex-col space-y-1.5 text-center sm:text-left">
      <h2
        id="radix-_r_27_"
        class="text-lg font-semibold leading-none tracking-tight"
      >
        Add New Display
      </h2>
      <p id="radix-_r_28_" class="text-sm text-muted-foreground">
        Configure your e-ink price display and connect it to the system.
      </p>
    </div>
    <div class="grid gap-4 py-4">
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="name"
          >Display Name</label
        ><input
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 col-span-3"
          id="name"
          placeholder="Enter display name"
        />
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="alias"
          >Alias</label
        ><input
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 col-span-3"
          id="alias"
          placeholder="Create a friendly name"
        />
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="serial"
          >Serial Number</label
        ><input
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 col-span-3"
          id="serial"
          placeholder="Enter serial number"
        />
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="location"
          >Location</label
        ><input
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 col-span-3"
          id="location"
          placeholder="Display location"
        />
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          >Size</label
        ><button
          type="button"
          role="combobox"
          aria-controls="radix-_r_4o_"
          aria-expanded="false"
          aria-autocomplete="none"
          dir="ltr"
          data-state="closed"
          class="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&amp;&gt;span]:line-clamp-1 col-span-3"
        >
          <span style="pointer-events: none">2.7 inch (264x176)</span
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-down h-4 w-4 opacity-50"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          >Template</label
        ><button
          type="button"
          role="combobox"
          aria-controls="radix-_r_4p_"
          aria-expanded="false"
          aria-autocomplete="none"
          dir="ltr"
          data-state="closed"
          class="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&amp;&gt;span]:line-clamp-1 col-span-3"
        >
          <span style="pointer-events: none">Standard</span
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-chevron-down h-4 w-4 opacity-50"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </button>
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="product"
          >Product Name</label
        ><input
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 col-span-3"
          id="product"
          placeholder="Enter product name"
        />
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <label
          class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-right text-sm"
          for="price"
          >Price</label
        >
        <div class="col-span-3 flex gap-2">
          <input
            class="flex h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-24"
            id="price"
            placeholder="0.00"
          /><button
            type="button"
            role="combobox"
            aria-controls="radix-_r_4q_"
            aria-expanded="false"
            aria-autocomplete="none"
            dir="ltr"
            data-state="closed"
            class="flex h-10 items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&amp;&gt;span]:line-clamp-1 w-32"
          >
            <span style="pointer-events: none">each</span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-down h-4 w-4 opacity-50"
              aria-hidden="true"
            >
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <div class="text-right text-sm">Sale Price</div>
        <div class="col-span-3 flex items-center gap-2">
          <div class="flex items-center space-x-2">
            <button
              type="button"
              role="checkbox"
              aria-checked="false"
              data-state="unchecked"
              value="on"
              class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground"
              id="has-sale"
            ></button
            ><label for="has-sale" class="text-sm">Enable sale price</label>
          </div>
          <input
            class="flex h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-24"
            placeholder="0.00"
          />
        </div>
      </div>
      <div class="grid grid-cols-4 items-center gap-4">
        <div class="text-right text-sm">Advanced Settings</div>
        <div class="col-span-3">
          <div class="flex items-center space-x-2">
            <button
              type="button"
              role="switch"
              aria-checked="false"
              data-state="unchecked"
              value="on"
              class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input"
              id="auto-config"
            >
              <span
                data-state="unchecked"
                class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
              ></span></button
            ><label for="auto-config" class="text-sm">Auto Configuration</label>
          </div>
          <p class="text-xs text-muted-foreground mt-1">
            Automatically detect and apply optimal settings for the display
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
      <button
        @click="$emit('cancel')"
        class="ring-offset-background focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border-input bg-background hover:bg-accent hover:text-accent-foreground border h-10 px-4 py-2"
      >
        Cancel</button
      ><button
        @click="$emit('confirm')"
        class="ring-offset-background focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
      >
        Add Display
      </button>
    </div>
    <button
      type="button"
      @click="$emit('cancel')"
      class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-x h-4 w-4"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>
<script lang="js">
export default {
  name: "EditDisplay",
};
</script>
